import type { AxiosError } from 'axios';

export const isTimeoutError = (error: unknown): boolean => {
  const err = error as AxiosError;
  return err?.code === 'ECONNABORTED' || err?.message?.toLowerCase().includes('timeout');
};

export const isNetworkError = (error: unknown): boolean => {
  const err = error as AxiosError;
  return err?.code === 'ERR_NETWORK' || (!err?.response && !isTimeoutError(error));
};
